import Reveal from "../Reveal";

export default function Solution() {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="py-28 md:py-40 bg-[#0F172A] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
              03 — The Solution
            </p>
            <h2
              data-testid="solution-headline"
              className="font-display font-light tracking-tighter leading-[0.95] text-[#F9F6F0] text-5xl md:text-6xl lg:text-7xl"
            >
              Storytelling <br /> with <span className="italic text-[#C86A53]">purpose.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 lg:pt-6 space-y-6 text-lg md:text-xl leading-relaxed font-light text-[#F9F6F0]/80">
            <p>
              At All We Do Is Write, we help organisations uncover, shape and share
              the stories already happening inside their business.
            </p>
            <p>
              When people understand your story, they are more likely to engage with it.
            </p>
            <p>
              Whether you're communicating with customers, employees, stakeholders or
              communities, storytelling helps people connect with what you do — and why
              it matters.
            </p>
          </Reveal>
        </div>

        {/* Pillars */}
        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 border-t border-[#1E293B]">
          {[
            { k: "Uncover", v: "Find the stories already happening inside your business." },
            { k: "Shape", v: "Craft them into messages that resonate with the people who matter." },
            { k: "Share", v: "Get them in front of customers, teams and stakeholders." },
          ].map((p, i) => (
            <Reveal key={p.k} delay={i * 0.1}>
              <div
                data-testid={`solution-pillar-${i}`}
                className="p-8 md:p-12 border-b md:border-b-0 md:border-r last:border-r-0 border-[#1E293B] h-full"
              >
                <p className="text-[11px] uppercase tracking-[0.3em] text-[#C86A53] mb-4">
                  Step 0{i + 1}
                </p>
                <h3 className="font-display text-4xl md:text-5xl text-[#F9F6F0] mb-4 font-light">
                  {p.k}.
                </h3>
                <p className="text-[#F9F6F0]/70 leading-relaxed font-light">{p.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
